export default "__VITE_ASSET__C_PtZmSt__"